import { createSlice } from '@reduxjs/toolkit'
import { SsoCompany } from './types'

export interface SsoState {
  companies: SsoCompany[]
  isLoading: boolean
  error: string | null
}

const INITIAL_STATE: SsoState = {
  companies: [],
  isLoading: false,
  error: null,
}

const ssoSlice = createSlice({
  name: 'sso',
  initialState: INITIAL_STATE,
  reducers: {
    setCompanies: (state, action) => {
      state.companies = action.payload
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
    },
    getSsoCompaniesSuccess: (state, action) => {
      state.companies = action.payload
      state.isLoading = false
      state.error = null
    },
    getSsoCompaniesFailed: (state, action) => {
      state.isLoading = false
      state.error = action.payload
    },
  },
})

export const ssoReducer = ssoSlice.reducer
export const ssoReducers = {
  ...ssoSlice.actions,
}
